import { render, staticRenderFns } from "./CXSettings.vue?vue&type=template&id=36dde7aa&scoped=true&"
import script from "./CXSettings.vue?vue&type=script&lang=js&"
export * from "./CXSettings.vue?vue&type=script&lang=js&"
import style0 from "./CXSettings.vue?vue&type=style&index=0&id=36dde7aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dde7aa",
  null
  
)

export default component.exports